import { connect } from "knockout-store";

function loaderViewmodel(params) {
  return {};
}

function mapStateToParams({}) {
  return {};
}

export default connect(mapStateToParams)(loaderViewmodel);
